function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUsdp(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M12 19.008a1.762 1.762 0 110 3.524 1.762 1.762 0 010-3.524zm-5.25-7.867l1.561.882a3.754 3.754 0 002.527 4.26l.106.033v1.805a2.86 2.86 0 00-1.645 1.732H3.982l-1.906-3.47L4.62 11.75a2.84 2.84 0 002.13-.61zm10.5 0a2.84 2.84 0 002.13.61l2.544 4.632-1.906 3.47h-5.317a2.86 2.86 0 00-1.54-1.688l-.105-.044v-1.805a3.754 3.754 0 002.66-4.124l-.027-.169 1.561-.882zM12 10.23a2.485 2.485 0 110 4.97 2.485 2.485 0 010-4.97zm7.037-3.073a1.762 1.762 0 110 3.524 1.762 1.762 0 010-3.524zm-14.074 0a1.762 1.762 0 110 3.524 1.762 1.762 0 010-3.524zM9.68 2.532h4.638l2.514 4.578a2.84 2.84 0 00-.636 2.066l.014.126-1.482.837A3.742 3.742 0 0012 8.962a3.74 3.74 0 00-2.641 1.087l-.087.09-1.483-.837a2.84 2.84 0 00-.621-2.19L9.68 2.53z"
  }));
}

SvgUsdp.clsName = 'icon-www__usdp';
SvgUsdp.remarkName = 'unknown';
export default SvgUsdp;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Usdp.js
// module id = 2522
// module chunks = 17 18